import axios from 'axios';

export default class FactsheetDataModels {
  constructor(props) {
    this.props = props;
  }

  async GetPromoBoxDetails(promoType) {
    const getDetails = async () => {
      return this.get(promoType + '.txt');
    };
    const details = await getDetails();
    if (details) {
      const detailsArr = details.split('\r\n\r\n');
      if (detailsArr && detailsArr.length === this.props.promoLines) {
        const promo = {
          title: detailsArr[0],
          description: detailsArr[1],
          value: detailsArr[2],
          source: detailsArr[3]
        };
        //console.log(promo);
        return promo;
      }
    }
    return null;
  }

  async get(name) {
    const axiosSvc = axios.create(this.props);
    let response = await axiosSvc.get(name);
    if (
      response &&
      response.status >= 200 &&
      (response.status < 300 || response.status === 304)
    ) {
      return response.data;
    } else {
      Console.error(
        `Error getting item '${name}': ${response.status} - ${response.statusText}`
      );
    }
  }
}
